/** URL segment of the Recurring Shifts page (formerly "Schedule Template" at `master-schedule`). */
export const RECURRING_SHIFTS_SEGMENT = "recurring-shifts";

export const recurringShiftsPath = (departmentId: string): string => `/${departmentId}/${RECURRING_SHIFTS_SEGMENT}`;
